export enum TagContext {
  SUCCESS = 'success',
  WARNING = 'warning',
  // The voyage page only wires up success/current/warning/error/neutral colors for c-tag
  // (see public/assets/css/pages/voyage/vars.css) — INFO has no color mapping there and
  // renders unstyled. Use CURRENT (blue) on that page instead.
  INFO = 'info',
  CURRENT = 'current',
  ERROR = 'error',
  DEFAULT = 'default',
}
